import {
  GSItemList,
  GSSplitView,
  useMediaQuery,
  defaultBorders,
  defaultGapping,
  defaultLayouts,
  defaultPadding,
  defaultTypography,
  GSField,
  GSButton,
  GSInput,
} from "golfstatus_react_components";
import DonationLineItem from "../events/donation-line-item";
import { useDispatch, useSelector } from "react-redux";
import {
  selectTournamentPaymentSettings,
} from "../../reducers/tournamentSlice";
import {
  addDonationToOrderThunk,
  removeDonationOrderItemThunk,
  selectLoading,
  selectRegistrationOrder,
  updateDonationItemThunk,
} from "../../reducers/registrationOrderSlice";
import { moneyWithCommas } from "../../helpers/RegexHelper";
import { useTheme } from "../../hooks/themeHooks";
import { faDollarSign } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { useTournament } from "../../hooks/tournamentHooks";

const FullDonationWidget = (props) => {
  const { style } = props;
  const tournament = useTournament();
  const tournamentPaymentSettings = useSelector(
    selectTournamentPaymentSettings
  );

  const registrationOrder = useSelector(selectRegistrationOrder);
  const loading = useSelector(selectLoading)?.filter?.(n => n === "addDonationToOrderThunk")

  const donation = registrationOrder?.donationOrderItems?.find?.(
    (d) => !d.roundUp
  );

  const { customDonationValues } = tournamentPaymentSettings;

  const { isPhone } = useMediaQuery();

  const [, theme, getStyle] = useTheme();

  const dispatch = useDispatch();
  

  const parseDonationAmount = (amount) => {
    const str = String(amount ?? "").trim();
    if (!/^(\d+(\.\d{1,2})?|\.\d{1,2})$/.test(str)) return null;
    return parseFloat(str);
  };

  const isValidDonationAmount = (amount) =>
    (parseDonationAmount(amount) ?? 0) >= 0.01;

  const donate = (amount) => {
    if(loading.length > 0){
      return
    }
    const parsed = parseDonationAmount(amount);
    if (parsed === null) {
      return;
    }
    if (donation?.id && parsed === 0) {
      dispatch(removeDonationOrderItemThunk(donation));
      return;
    }
    if (parsed < 0.01) {
      return;
    }
    if (donation?.id) {
      dispatch(updateDonationItemThunk({ ...donation, amount }));
    } else {
      dispatch(addDonationToOrderThunk({ amount, registrationOrder: {...registrationOrder, tournament} }));
    }
  };

  const [textvalue, setTextValue] = useState(donation?.amount ?? 0);

  useEffect(() => {
    if (donation?.amount) {
      setTextValue(donation?.amount);
    }
  }, [donation?.amount]);

  const getBorderStyle = (value) => {
    if (value === donation?.amount) {
      return {
        border: "4px solid",
      };
    } else {
      return {
        border: "4px solid transparent",
      };
    }
  };

  const donationInput = (value) => {
    return (
      <div
        style={{
          ...defaultLayouts.hStack.align("flex-start", "center"),
          ...defaultGapping.mediumGap,
        }}
      >
        <GSInput
          textValue={textvalue}
          onChange={(e) => {
            const v = e?.target?.value ?? "";
            if (v === "" || /^\d*(\.\d{0,2})?$/.test(v)) {
              setTextValue(v);
            }
          }}
          placeholder="0.00"
          leftIcon={faDollarSign}
        ></GSInput>
        <GSButton
          isFocusable={true}
          title={"Apply"}
          type="black"
          isDisabled={
            !isValidDonationAmount(textvalue) &&
            !(donation?.id && parseDonationAmount(textvalue) === 0)
          }
          onClick={() => {
            donate(textvalue);
          }}
        />
      </div>
    );
  };

  return (
    <GSSplitView
      style={style}
      dividerStyle={{ width: "0" }}
      left={
        <div
          style={{
            ...defaultLayouts.fill,
            ...defaultLayouts.vStack.align("flex-start", "center"),
            ...defaultGapping.mediumLargeGap,
          }}
        >
          <h2 style={{ ...defaultTypography.headline2 }}>Make a Donation</h2>
          <DonationLineItem
            {...tournament}
            {...tournamentPaymentSettings}
            hideValues={true}
            style={{ ...defaultLayouts.fullWidth }}
          />
        </div>
      }
      right={
        <div
          style={{
            ...defaultLayouts.vStack,
            ...defaultLayouts.fullWidth,
            ...defaultGapping.xLargeGap,
          }}
        >
          <GSItemList
            type="inline-grid medium-large-gap selectable"
            style={{ ...defaultLayouts.fullWidth }}
            gridColumns={isPhone() ? 1 : 2}
            items={customDonationValues ?? []}
            itemSelected={(donation) => {
              donate?.(donation);
            }}
            listItem={(donation) => (
              <div
                className="donation-option hover-outline"
                style={{
                  ...defaultPadding.xLargePad,
                  ...defaultLayouts.fullWidth,
                  ...getStyle(theme.surface),
                  ...defaultLayouts.vStack.align("center", "center"),
                  ...defaultBorders.mediumLargeBorderRadius,
                  ...defaultTypography.body,
                  ...getBorderStyle(donation),
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    ...defaultTypography.overline2,
                    opacity: 0.7,
                    ...defaultTypography.uppercase,
                  }}
                >
                  Donate
                </div>
                {moneyWithCommas(donation, true)}
              </div>
            )}
          />
          <GSField
            required={true}
            value={donationInput()}
            label="donation amount"
            isEditable={true}
            customView={true}
            style={{ ...defaultLayouts.fullWidth }}
          />
        </div>
      }
    />
  );
};

export default FullDonationWidget;
